import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { ResumeProvider } from './context/ResumeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ResumeProvider>
      <App />
    </ResumeProvider>
  </React.StrictMode>
);

// If you want to expose the app to be used in a SquareSpace environment
if (typeof window !== 'undefined') {
  window.InteractiveResume = {
    init: (containerId) => {
      const container = document.getElementById(containerId);
      if (container) {
        const root = ReactDOM.createRoot(container);
        root.render(
          <ResumeProvider>
            <App />
          </ResumeProvider>
        );
        return true;
      }
      return false;
    }
  };
}
